<!-- Header with Navigation -->
<header class="app-header">
  <div class="container-fluid d-flex align-items-center justify-content-between">
    <div class="header-left d-flex align-items-center gap-3">
      <h1 class="header-title mb-0">CE Request Flow</h1>
      <nav class="header-nav">
        <ul class="nav-menu">
          @for (item of visibleNavigationItems(); track $index) {
            <li class="nav-item" [class.active]="item.active">
              <button
                type="button"
                class="nav-link"
                [disabled]="!isMenuItemClickable(item)"
                (click)="navigate(item)"
              >
                {{ item.label }}
              </button>
            </li>
          }
        </ul>
      </nav>
    </div>
  </div>
</header>

<!-- Main Content -->
<main class="page container-fluid">
  <div class="global-toast-container">
    @for (note of notifications.notifications(); track note.id) {
      <div class="global-toast" [class.global-toast--error]="note.kind === 'error'" [class.global-toast--success]="note.kind === 'success'" role="status" aria-live="polite">
        {{ note.message }}
      </div>
    }
  </div>

  <router-outlet></router-outlet>
</main>
